module.exports = __webpack_public_path__ + "img/flickr.1824ca87.svg";